<template>
  <div class="law">
    <div class="auto_1280" v-html="content"></div>
  </div>
</template>
<script>
export default {
  name: 'Law',
  data () {
    return {
      articleTypeId: 35,
      content: {},
      lan: this.$store.state.isEn
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
    const self = this
    self.initId()
    self.init()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.content = {}
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 20, bLanguage: this.lan }, r => {
        let content = r.data[0].content.replace(/%/g, '%25')
        self.content = decodeURIComponent(content)
      })
    }
  }
}
</script>
<style scoped>
.law{padding: 2% 0 5%;}
.law .txt,
.law span,
.law p{margin: 0;}
@media(max-width: 640px){
  .law .txt,
  .law span,
  .law p{font-size: 14px!important; line-height: 1.8!important;}
}
</style>
